function handleFreeShippingMeter() {
  const _m = {
    async getCart() {
      const result = await fetch("/cart.json");

      if (result.status === 200) {
          return result.json();
      }
      throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`);
    },

    meterGradient(num) {
      const transition = num < 100 ? num : 100
      return `linear-gradient(to right,
                              rgba(214, 198, 177, 100)  ${transition}%,
                            rgba(0, 0, 0, 0.099) ${transition}%)`
    },

    updateIndicator(price) {
      const meter = document.querySelector('.gdc-cart-free-shipping-meter')
      const icon = document.querySelector('.gdc-cart-free-shipping-meter__icon')

      meter.style.backgroundImage = _m.meterGradient(price)
      icon.style.left = `${price < 100 ? price : 100}%`
    },

    updateFreeShippingMessage(price) {
      const freeShippingLimit =  document.querySelector('.gdc-cart-free-shipping-meter').dataset.freeShippingLimit
      const amountLeft = Math.ceil(freeShippingLimit - price)
      const container = document.querySelector('.gdc-cart-free-shipping-meter__message')
      const msg = amountLeft > 0 ? `Only $${amountLeft} away from FREE shipping.` : "Congrats! You've unlocked <b>FREE SHIPPING!</b>"

      container.innerHTML = msg
    },

    getCountryData() {
      return fetch('/browsing_context_suggestions.json')
        .then((response) => response.json())
        .then((data) => data.detected_values.country.name)
    },

    showMeter() {
      document.querySelector('.gdc-cart-free-shipping-meter__wrapper').classList.remove('hidden')
    },

    updateFreeShippingMeter() {
      setTimeout(() => {
        _m.showMeter() 
        getCart().then((data) => { 
          const price = data.total_price / 100
    
          _m.updateIndicator(price)
          _m.updateFreeShippingMessage(price)
        })
      }, 1000);
    },

    init() {
      const cartDrawer = document.getElementById('cart-drawer');
      const config = { attributes: true, children: true, subtree: true };

      const callback = (mutationList, observer) => {
        // UNCOMMENT FOR TROUBLE SHOOTING
        // for (const mutation of mutationList) {
        //   if (mutation.type === "childList") {
        //     console.log("A child node has been added or removed.");
        //   } else if (mutation.type === "attributes") {
        //     console.log(`The ${mutation.attributeName} attribute was modified.`);
        //   }
        // }

        _m.getCountryData().then(country => {
          if (country === "Canada" || country === "United States") {
            if (cartDrawer.classList.contains('is-open')) {
              _m.updateFreeShippingMeter()
            }
          } 
        })
      };

      if (cartDrawer) {
        const observer = new MutationObserver(callback);
        observer.observe(cartDrawer, config);
      }
    }
  }

  _m.init()
}


window.addEventListener('DOMContentLoaded', handleFreeShippingMeter)
